import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import {
  SaveSalesPortalCart_CartItemFieldsFragmentDoc,
  SaveSalesPortalCart_ErrorFieldsFragmentDoc,
  SaveSalesPortalCart_MetadataFieldsFragmentDoc,
} from './save-sales-portal-cart-fragments.generated';
const defaultOptions = {} as const;

export const SaveSalesPortalCartDocument = gql`
  mutation SaveSalesPortalCart($cart: SalesPortalCartInput!) {
    saveSalesPortalCart(cart: $cart) {
      cart {
        metadata {
          ...SaveSalesPortalCart_MetadataFields
        }
        cart_items {
          ...SaveSalesPortalCart_CartItemFields
        }
      }
      success
      error {
        ...SaveSalesPortalCart_ErrorFields
      }
    }
  }
  ${SaveSalesPortalCart_MetadataFieldsFragmentDoc}
  ${SaveSalesPortalCart_CartItemFieldsFragmentDoc}
  ${SaveSalesPortalCart_ErrorFieldsFragmentDoc}
`;
export type SaveSalesPortalCartMutationFn = Apollo.MutationFunction<
  Types.SaveSalesPortalCartMutation,
  Types.SaveSalesPortalCartMutationVariables
>;
export function useSaveSalesPortalCartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SaveSalesPortalCartMutation,
    Types.SaveSalesPortalCartMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SaveSalesPortalCartMutation,
    Types.SaveSalesPortalCartMutationVariables
  >(SaveSalesPortalCartDocument, options);
}
export type SaveSalesPortalCartMutationHookResult = ReturnType<
  typeof useSaveSalesPortalCartMutation
>;
export type SaveSalesPortalCartMutationResult =
  Apollo.MutationResult<Types.SaveSalesPortalCartMutation>;
export type SaveSalesPortalCartMutationOptions = Apollo.BaseMutationOptions<
  Types.SaveSalesPortalCartMutation,
  Types.SaveSalesPortalCartMutationVariables
>;
